import { FC } from "react"
import { Box, MenuList } from "@mui/material"

import { profileIconsPack } from "@/consts.tsx"
import HeaderProfileItem from "../HeaderProfileItem"
import HeaderProfileThemeItem from "../HeaderProfileThemeItem"
import {
  handleOpenCloseMenu,
  menuBlurCont,
  sideMenuCont,
} from "./headerProfileMenuStyles"

type Props = {
  isOpenMenu: boolean
  isOrganizerRole: boolean
}

const HeaderProfileMenu: FC<Props> = ({ isOpenMenu, isOrganizerRole }) => {
  const filteredProfileIconsPack = isOrganizerRole
    ? profileIconsPack
    : profileIconsPack.filter((item) => item.text !== "Кабинет организатора")

  return (
    <MenuList sx={sideMenuCont} style={handleOpenCloseMenu(isOpenMenu)}>
      {filteredProfileIconsPack.map((item, i) =>
        item.text != "Тема" ? (
          <HeaderProfileItem
            item={item}
            i={i}
            isOpenMenu={isOpenMenu}
            key={i}
          />
        ) : (
          <HeaderProfileThemeItem
            i={i}
            item={item}
            isOpenMenu={isOpenMenu}
            key={i}
          />
        ),
      )}
      <Box sx={menuBlurCont} onClick={() => handleOpenCloseMenu(false)} />
    </MenuList>
  )
}

export default HeaderProfileMenu
